




















import { Component, Vue, Prop } from 'vue-property-decorator';
import ArticleActions from '@/components/article/ArticleActions.vue';
import { Article } from '@/services/articles';

@Component({
  components: {
    ArticleActions
  }
})
export default class ArticleMeta extends Vue {
  @Prop({ required: true }) article!: Article;
  @Prop() actions!: boolean;

  isCurrentUser() {
    if (this.currentUser.username && this.article.author.username) {
      return this.currentUser.username === this.article.author.username;
    }

    return false;
  }

  get currentUser() {
    return this.$store.getters['auth/currentUser'];
  }
}
